import { GET_TENANT_CONFIG, UPDATE_CURRENT_APP_VERSION, UPDATE_TENANT_CONFIG, UPDATE_TENANT_CONFIG_SUCCESS, UPDATE_TENANT_CONFIG_ERROR, SETLOCATION_NAVIGATION, SETLOCATION_HOME_NAVIGATION, } from '../../constants';
export function getTenantConfig(tenantCode) {
    return {
        type: GET_TENANT_CONFIG,
        country: tenantCode,
    };
}
export function updateCurrentVersion(version) {
    return {
        type: UPDATE_CURRENT_APP_VERSION,
        version,
    };
}
export function getTenantConfigUpdate(request) {
    return {
        type: UPDATE_TENANT_CONFIG,
        request,
    };
}
export function tenantConfigUpdateSuccess(response) {
    return {
        type: UPDATE_TENANT_CONFIG_SUCCESS,
        response,
    };
}
export function tenantConfigUpdateError(error) {
    return {
        type: UPDATE_TENANT_CONFIG_ERROR,
        error,
    };
}
export function promosandrewards(coupon) {
    return {
        type: SETLOCATION_NAVIGATION,
        payload: coupon,
    };
}
export function promosandrewardsFromHome(coupon) {
    return {
        type: SETLOCATION_HOME_NAVIGATION,
        payload: coupon,
    };
}
